import { useState, useEffect } from "react";
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import { ArrowRight } from "lucide-react";
import "../styles/listeProjets.css";

export function ListeProjets({ isHome }) {
    const navigate = useNavigate();
    const listP = useSelector(s => s.listP) || [];
    const cherche = useSelector(s => s.cherche) || "";
    const list = listP.filter(a => (a.nomProjet || "").toLowerCase().includes(cherche.toLowerCase()));

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    let limit = list.length;
    if (isHome) {
        if (width >= 5120) limit = 12;
        else if (width >= 3400) limit = 10;
        else if (width >= 2000) limit = 10;
        else if (width >= 1536) limit = 8;
        else if (width >= 1110) limit = 6;
        else if (width >= 1000) limit = 6;
        else if (width >= 600) limit = 4;
        else limit = 4;
    }

    const displayedList = list.slice(0, limit);

    return (
        <>
            {!isHome && <Navbar />}
            <div className={`projets-list-container ${!isHome ? 'full-page-list' : ''}`}>
                <div className="projets-title-bar" style={!isHome ? { backgroundColor: '#000033' } : {}}>
                    Les projets
                </div>

                <div className="projets-grid">
                    {displayedList.map(a => (
                        <div key={a.id} className="projet-card" onClick={() => navigate(`/listeProjets/${a.id}`, { state: { fromList: true } })} style={{ cursor: 'pointer' }}>
                            <div className="projet-image-wrapper">
                                <img src={a.imageProjet} alt={a.nomProjet} />
                            </div>
                            <div className="projet-info">
                                <h3 className="projet-name">{a.nomProjet}</h3>
                                <Link to={`/listeProjets/${a.id}`} state={{ fromList: true }} onClick={(e) => e.stopPropagation()} className="btn-details" style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                    Plus de détails <ArrowRight className="icon-arrow" />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                {list.length === 0 && cherche && (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p>Aucun projet trouvé pour "{cherche}"</p>
                    </div>
                )}

                {isHome && (
                    <div className="projets-view-all-container">
                        <button className="btn-projets-view-all" onClick={() => navigate('/listeProjets')}>
                            Voir tous les projets
                        </button>
                    </div>
                )}
            </div>
            {!isHome && <Contact />}
        </>
    );
}
